import { defaultShouldDehydrateQuery, isServer, MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { HttpClientError } from '@/api/errors';
import { ErrorCode } from '@/components/ErrorOverlay/errorConfigs';
import { useErrorStore } from '@/stores/errorStore';

function makeQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      // TODO: We want to only show errors for player for now, we need to discuss some more on how we should handle these errors globally
      // onError: (error: unknown) => {
      //   if (error instanceof HttpClientError) {
      //     const code = error.status;
      //     if (ErrorCode[code]) {
      //       useErrorStore.getState().addError({ code });
      //     }
      //   }
      // },
    }),
    mutationCache: new MutationCache({
      onError: (error: unknown, _variables, _context, mutation) => {
        if (mutation.meta?.skipGlobalError) {
          return;
        }

        if (error instanceof HttpClientError) {
          const code = error.status;

          if (ErrorCode[code]) {
            useErrorStore.getState().addError({ code });
          }
        }
      },
    }),
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
      },
      dehydrate: {
        // include pending queries in dehydration
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

export default function getQueryClient(): QueryClient {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient();
  }

  // Browser: make a new query client if we don't already have one
  // This is very important, so we don't re-make a new client if React
  // suspends during the initial render. This may not be needed if we
  // have a suspense boundary BELOW the creation of the query client
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }

  return browserQueryClient;
}
